/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.1
 */

import styled from 'styled-components';

export const WidgetSkeletonParagraphStyled = styled.div.attrs({
    className: 'widget__widget-skeleton widget__widget-skeleton_paragraph',
})`
    & .skeleton__paragraph {
        margin-bottom: 8px;
    }
    
    & .skeleton__paragraph:last-child {
        margin-bottom: 24px;
    }
`;

export const WidgetSkeletonParagraphNormalStyled = styled.div.attrs({
    className: 'widget__widget-skeleton widget__widget-skeleton_paragraph widget__widget-skeleton_paragraph_normal',
})`
    width: 100%;
`;

export const WidgetSkeletonButtonStyled = styled.div.attrs({
    className: 'widget__widget-skeleton widget__widget-skeleton_button',
})``;

export const WidgetSkeletonChartStyled = styled.div.attrs({
    className: 'widget__widget-skeleton widget__widget-skeleton_chart',
})``;

